export const debounce = (fn: (...args: any) => void, delay = 400) => {
  let timerId: ReturnType<typeof setTimeout>;

  return (...args: unknown[]) => {
    clearTimeout(timerId);

    timerId = setTimeout(() => fn(...args), delay);
  };
};
